<template>
    <a :href="prefix + '/cabinet'" class="btn btn--white-bg header__button header__button--d header__button--admin"
        itemprop="url">
        <span class="header__button-icon">
            <svg width="20" height="20">
                <use xlink:href="/assets/front/img/sprite.svg#icon-statistic"></use>
            </svg>
        </span>
    </a>
</template>

<script>
export default {
    name: 'HeaderDesktopButton',
    data() {
        return {
            prefix: window.laravel.prefix
        }
    }
}
</script>
